import { CheckboxField } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../common/state';
import { getTermValue } from '../../../../json_query/reducers/helpers';
import { changeIsByHomeowner } from '../../../state/is_by_homeowner';
import { InlineParam, Row } from '../markup';

export interface IIsByHomeOwnerProps {
  value: boolean;
  onChange(value: boolean): void;
}

class IsByHomeOwner extends React.PureComponent<IIsByHomeOwnerProps> {
  public render() {
    return (
      <Row title="Автор объявления">
        <InlineParam>
          <CheckboxField label="От собственника" value={this.props.value} onValueChange={this.props.onChange} />
        </InlineParam>
      </Row>
    );
  }
}

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    value: Boolean(getTermValue('is_by_homeowner')(state.filters.jsonQuery)),
  }),
  (dispatch: Dispatch) => ({
    onChange: (value: boolean) => dispatch(changeIsByHomeowner(value)),
  }),
)(IsByHomeOwner);
